module.exports = __webpack_public_path__ + "static/nutrien-de7a8492f576e3c1e165c50a5db37d9b.png";